<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přehled promo kódů
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="orderHeadersByRole"
        :items="promoCode.items"
        :options.sync="promoCode.options"
        :server-items-length="promoCode.serverItemsLength"
        :loading="promoCode.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.orderId="{ item }">
          <router-link
            :to="{
              name: 'orders.detail',
              params: {
                orderId: item.orderId,
              },
            }"
          >
            {{ item.orderId }}
          </router-link>
        </template>
        <template v-slot:item.gift.id="{ item }">
          <router-link
            :to="{
              name: 'gifts.detail',
              params: {
                giftId: item.gift.id,
              },
            }"
          >
            {{ item.gift.id }}
          </router-link>
        </template>
        <template v-slot:item.used="{ item }">
          <YesNo :value="item.used" />
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import YesNo from '../YesNo'

export default {
  name: 'CustomerPromoCodes',
  components: {
    YesNo,
    DateTime,
  },
  mixins: [setFilters],
  props: {
    id: {
      id: Number,
      required: true,
    },
  },
  data() {
    return {
      promoCode: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Id objednávky',
            value: 'orderId',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Id dárku',
            value: 'gift.id',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Název dárku',
            value: 'gift.name',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Kód',
            value: 'code',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Odeslaný',
            value: 'used',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      promoCodeFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    orderHeadersByRole() {
      return this.promoCode.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    status: {
      handler() {
        this.loadPromoCodes()
      },
    },
    'promoCode.options': {
      handler() {
        this.loadPromoCodes()
      },
    },
    '$route.query': {
      handler() {
        this.loadPromoCodes()
      },
    },
  },
  methods: {
    ...mapActions({
      searchCustomerPromoCodes: 'customer/searchCustomerPromoCodes',
    }),
    loadPromoCodes() {
      this.promoCode.loading = true
      const searchParams = {
        options: this.promoCode.options,
      }
      this.searchCustomerPromoCodes({ id: this.id, params: searchParams })
        .then((response) => {
          this.promoCodeFooter.totalElements = response.data.totalElements
          this.promoCode.items = response.data.items
          this.promoCode.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.promoCode.loading = false
        })
    },
    setFiltersAction(filters) {
      this.promoCode.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
